var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIconSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.071 8l4.911-5.637 4.984 5.512L12 6.675 5.944.001 0 6.84 1.071 8z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjA3MTQzIDhMNS45ODE5OCAyLjM2Mjk4TDEwLjk2NjMgNy44NzVMMTIgNi42NzQ5OUw1Ljk0NDI4IDAuMDAwOTc1MTgxTC0yLjAwOTQ5ZS0wNiA2LjgzOTk3TDEuMDcxNDMgOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgArrowIconSvg as ReactComponent };